import { TRootState } from "../@types"

export const selectModalSystemVariables = ( state: TRootState ) =>state.systemVariables.systemVariablesModalIsOpen

export const selectIsUpdateSystemVariables = ( state: TRootState ) =>state.systemVariables.isUpdateSystemVariables

export const selectSystemVariablesForUpdate = ( state: TRootState ) =>state.systemVariables.systemVariablesForUpdate

export const selectSystemVariablesRefreshTable =  ( state: TRootState ) =>state.systemVariables.refreshTableSystemVariables
